import React, { useState } from "react";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  showToast,
  useFormHandler,
} from "../../../../../components";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import common from "../../../../../utils/common";
import { createInstantlyCampaign, getInstantlyAccessId } from "../../../../../redux/slices/compaigns/compaignsSlice";
import { useEffect } from "react";

const Options = () => {
  const dispatch=useDispatch()
  const { transformShuffleData,generateOutput,generateFinalOutputWithStaticFields } = common;
  const createCampaigns =useSelector((state) => state.compaigns?.instantly?.createCampaigns) || {};
  const [loading,setLoading]=useState(false);
   const campaignsAccessId = useSelector((state) => state.compaigns?.instantly?.accessId);
  const navigate = useNavigate();
  const initialData = {
    accountToUse: "",
    dailyLimit: "",
    ccRecipients: "",
    bccRecipients: "",
    owned_by:"",
    stop_on_reply:"1",
    open_tracking:"1",
    auto_variant_select:"reply_rate",
    insert_unsubscribe_header:"1",
    stop_for_company:"1",
    prioritize_new_leads:"1",
    email_gap:5,
    random_wait_max:2,
    first_email_text_only:"1",
    text_only:"",
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialData, {
      accountToUse: { type: "select", required: true },
      dailyLimit: { type: "text",number:true, required: true },
      
    });
  const handleSave = () => {
     if(validateAllFields()){
      // showToast("Please select the fileds", "error");
      // return ""
     }
    const action = {
      ...(formData.accountToUse.type === "acc"
        ? { email_list: [formData?.accountToUse.label] }
        : { email_tag_list: [formData?.accountToUse.value] }),
      bcc_list: formData?.bccRecipients
        ? formData.bccRecipients.split(" ")
        : [],
      cc_list: formData?.ccRecipients ? formData.ccRecipients.split(" ") : [],
      daily_limit: formData.dailyLimit,
      ...createCampaigns,
    };
    if (
      !action?.campaign_schedule ||
      !action?.daily_limit ||
      !action?.leads ||
      action.leads.length === 0 ||
      !action?.name ||
      !action?.steps ||
      action.steps.length === 0
    ) {
      showToast("Please fill each tab", "error");
      return; // stop execution
    }
    const leadsdecode=  action?.leadsType===5?generateOutput(action?.leads): action?.leads || []; // Fallback to empty array if action.leads is missing
    // const leadsdecode=  action?.leadsType === 2 || action?.leadsType === 3
    //         ? transformShuffleData(action?.leads|| []) // Safe check for leads
    //         : action?.leadsType===5?generateOutput(action?.leads): action?.leads || []; // Fallback to empty array if action.leads is missing
   const finalLeads=generateFinalOutputWithStaticFields(leadsdecode)
            const payload = {
      campaignPayload: {
        name: action.name,
        campaign_schedule: action.campaign_schedule,
        sequences:  [
    {
      steps: action.steps  // <-- use directly, don't wrap in []
    }
  ],
        ...(formData.accountToUse.type === "acc"
          ? { email_list: [formData?.accountToUse.label] }
          : { email_tag_list: [formData?.accountToUse.value] }),
        daily_limit: formData.dailyLimit,
        stop_on_reply: formData?.stop_on_reply==="1"?true:null,
        open_tracking: formData?.open_tracking==="1"?true:null,
        insert_unsubscribe_header: formData?.insert_unsubscribe_header==="1"?true:null,
        stop_for_company: formData?.stop_for_company==="1"?true:null,
        prioritize_new_leads: formData?.prioritize_new_leads==="1"?true:null,
        email_gap:formData?.email_gap,
        random_wait_max:formData?.random_wait_max,
        first_email_text_only:formData?.first_email_text_only==="1"?true:null,
        text_only:formData?.text_only==="1"?true:null,
        owned_by:formData?.owned_by,
        auto_variant_select: {"trigger": formData?.auto_variant_select},
        allow_risky_contacts: false,
        disable_bounce_protect: false,
        link_tracking: true,
        stop_on_auto_reply: true,
      },
      
      leadsPayload: {
        campaign_id: null,
        leads: finalLeads
  .map(lead =>
    Object.fromEntries(
      Object.entries(lead).filter(
        ([, value]) =>
          value !== null &&
          value !== undefined &&
          value !== "" &&
          !(typeof value === "string" && value.trim() === "")
      )
    )
  )
  .filter(lead => Object.keys(lead).length > 0)
      },
    };
    
    setLoading(true)
    dispatch(
  createInstantlyCampaign({
    payload,
    accessId: campaignsAccessId,
    onSuccess: (success, data) => {
      setLoading(false);
      if (success) {
        showToast("Successfully campaign created", "success");
        navigate("/ats/campaigns");
      } else {
        showToast("Campaign not created", "error");
      }
    },
  })
);
  };
  useEffect(()=>{
    const fetchIntantlyAccessIs=async()=>{
      if(!campaignsAccessId){
      dispatch(getInstantlyAccessId({fil:{category:{type:"NONE",value:11},type:{type:"NONE",value:5},status:{type:"NONE",value:1}},coll:"Integration"}))
      }
  // const reponse = await checkAdminAdded({fil:{category:{type:"NONE",value:11},type:{type:"NONE",value:5},status:{type:"NONE",value:1}},coll:"Integration"})
  //   if(reponse?.success){
  //     const Id= reponse?.data?.data?.uiid
  //     setIntantlyAccessId(Id)
  //   }
    }
    fetchIntantlyAccessIs()
  },[])
  return (
    <div className="flex-1 py-4 px-2">
      <div className="grid grid-cols-2 gap-5">
        <FormFieldSet
          type="getCampaignAccounts"
          title="Account to use (Select one or more accounts to send email from)"
          placeholder="Select"
          value={formData.accountToUse}
          // options={[
          //   { label: "Brown@tektree.inc", value: "1" },
          //   { label: "Adms@tektree.inc", value: "2" },
          //   { label: "asthav@tektree.inc", value: "3" },
          // ]}
          onChange={(value) => {
            handleChange("accountToUse", value);
          }}
          filters={{campaignsAccessId}}
          error={errors.accountToUse}
          showSearch
        />
        <FormFieldSet
          title="Daily Limit (Max number of email to send per day for this campaign)"
          placeholder="enter the number"
          value={formData.dailyLimit}
          onChange={(value) => handleChange("dailyLimit", value)}
          error={errors.dailyLimit}
        />
      </div>
      <Button
        title={"Connect new email Account"}
        color="info"
        variant="text"
        size="sm"
        className="text-info-600 font-medium !text-sm !px-0"
      />

      <h6 className="my-2 text-sm">
        CC and BCC
        <span className="text-gray-400">
          (Add CC and BCC recipient to all emails)
        </span>
      </h6>
      <div className="grid grid-cols-2 inner-section px-3 py-6 rounded-lg gap-4">
        <div>
          <p className="font-semibold text-sm">CC Recipients</p>
          <p className="text-xs mb-3 text-gray-400">
            Send a copy of the email to the address listed in the field
          </p>
          <FormFieldSet
            type="textArea"
            noTitle
            rows={6}
            placeholder="Seperate emails with a comma"
            value={formData.ccRecipients}
            onChange={(value) => handleChange("ccRecipients", value)}
            error={errors.ccRecipients}
          />
        </div>
        <div>
          <p className="font-semibold text-sm">BCC Recipients</p>
          <p className="text-xs mb-3 text-gray-400">
            Send a copy of the email to certain Recipient without the other
            recipient knowing about it
          </p>
          <FormFieldSet
            type="textArea"
            rows={6}
            noTitle
            placeholder="Seperate emails with a comma"
            value={formData.bccRecipients}
            onChange={(value) => handleChange("bccRecipients", value)}
            error={errors.bccRecipients}
          />
        </div>
      </div>
       <h6 className="my-2 text-sm">
        Advanced Options
      </h6>
      <div>
         <FormFieldSet
          type="getWorkSpaceUsers"
          title="Owner(Select the owner of this campaign)"
          placeholder="Select"
          value={formData.owned_by}
          onChange={(value) => {
            handleChange("owned_by", value?.value);
          }}
          filters={{campaignsAccessId}}
          error={errors.owned_by}
        />
      </div>
      <div className="grid grid-cols-2 inner-section px-3 py-6 rounded-lg gap-4">
          <div className="text-[12px] font-medium mb-0.5 min-h-[18px]">
            Delivery Optimization
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
         
            <FormFieldSet
              title="Minimum time"
              type="checkbox"
              placeholder="minutes"
              shadow={true}
              options={[{label:"Send emails as text-only (no HTML)",value:"1"}]}
              // value={formData?.stop_on_reply}
              values={formData?.text_only}
              onChange={(value)=>handleChange("text_only",value)}
            />
            <FormFieldSet
              // title="Minimum time"
              noTitle
              type="checkbox"
              placeholder="minutes"
              shadow={true}
              options={[{label:"Send first email as text-only",value:"1"}]}
              // value={formData?.stop_on_reply}
              values={formData?.first_email_text_only}
              onChange={(value)=>handleChange("first_email_text_only",value)}
            />
          </div>
        </div>
       <div className="grid grid-cols-2 inner-section px-3 py-6 rounded-lg gap-4">
          <div className="text-[12px] font-medium mb-0.5 min-h-[18px]">
            Time gap between emails
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            <FormFieldSet
              title="Minimum time"
              placeholder="minutes"
              shadow={true}
              value={formData?.email_gap}
              onChange={(value)=>handleChange("email_gap",value)}
            />
            <FormFieldSet
              title="Random additional time"
              placeholder="minutes"
              shadow={true}
              value={formData?.random_wait_max}
              onChange={(value)=>handleChange("random_wait_max",value)}
            />
          </div>
        </div>
        <div className="grid grid-cols-2 inner-section px-3 py-6 rounded-lg gap-4">
           <div className="text-[12px] font-medium mb-0.5 min-h-[18px]">
            Auto optimize A/Z Testing
          </div>
          <FormFieldSet
          type="select"
          title="Choose winning metric"
          placeholder="Select"
          value={formData.auto_variant_select}
          options={[
            { label: "Reply Rate", value: "reply_rate" },
            { label: "Click Rate", value: "click_rate" },
            { label: "Open Rate", value: "open_rate" },
          ]}
          onChange={(value) => {
            handleChange("auto_variant_select", value);
          }}
        />
        </div>
       
       <div className="grid grid-cols-2 inner-section px-3 py-6 rounded-lg gap-4">
        
        <FormFieldSet
        noTitle
        type="checkbox"
        options={[{"label":"Open Tracking",value:"1"}]}
        values={formData?.open_tracking}
        onChange={(value)=> handleChange("open_tracking", value)}
        />
        <FormFieldSet
        noTitle
        type="checkbox"
        options={[{"label":"Prioritize New Leads",value:"1"}]}
         values={formData?.prioritize_new_leads}
         onChange={(value)=> handleChange("prioritize_new_leads", value)}
        />
        <FormFieldSet
        noTitle
        type="checkbox"
        options={[{"label":"Stop Campaign for Company on Reply",value:"1"}]}
         values={formData?.stop_for_company}
         onChange={(value)=> handleChange("stop_for_company", value)}
        />
        <FormFieldSet
        noTitle
        type="checkbox"
        options={[{"label":"Insert Unsubscribe Link Header",value:"1"}]}
        values={formData?.insert_unsubscribe_header}
         onChange={(value)=> handleChange("insert_unsubscribe_header", value)}
        />
        <FormFieldSet
        noTitle
        type="checkbox"
        options={[{label:"Stop Sending Emails on Auto-Reply",value:"1"}]}
        values={formData?.stop_on_reply}
        onChange={(value)=> handleChange("stop_on_reply", value)}
        />
      </div>
      <div className="flex justify-end items-center gap-4 my-4">
        <Button title={"Save"} onClick={() => handleSave()} />
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop> 
    </div>
  );
};

export default Options;
